import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const header: SxStyle = {
  width: '100%',
  background: (p) => p.palette.primary[50],
  padding: (p) => p.spacing(1.5, 3),
  border: 0,

  borderBottom: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[300],
};

export const icon: SxStyle = {
  color: (p) => p.palette.primary[500],
};

export const content: SxStyle = {
  padding: (p) => p.spacing(3),
  border: 0,
  borderBottom: '1px',
  borderStyle: 'dashed',
  borderColor: (p) => p.palette.grey[300],
};

export const footer: SxStyle = {
  padding: (p) => p.spacing(1.5, 3),
  flex: 1,
  width: '100%',
};

export const title: SxStyle = {
  fontSize: (p) => p.typography.h6,
};

export const text: SxStyle = {
  fontSize: (p) => p.typography.body2,
};

export const button: SxStyle = {};
